import { createStackNavigator } from '@react-navigation/stack'
import React from 'react'
import { ControlServicesRoutes } from '../types'
import {
  CategoryFour,
  CategoryThree,
  CategoryTwo,
  ControlServices,
  DetailControlServices,
  FinalForm,
  JobsAndChore,
} from '../../modules'
const Stack = createStackNavigator<ControlServicesRoutes>()

export const ControlServicesStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: false,
      }}
    >
      <Stack.Screen name='ControlServices' component={ControlServices} />
      <Stack.Screen name='CategoryTwo' component={CategoryTwo} />
      <Stack.Screen name='CategoryThree' component={CategoryThree} />
      <Stack.Screen name='CategoryFour' component={CategoryFour} />
      <Stack.Screen name='FinalForm' component={FinalForm} />
      <Stack.Screen name='DetailControlServices' component={DetailControlServices} />
      <Stack.Screen name='JobsAndChore' component={JobsAndChore} />
    </Stack.Navigator>
  )
}
